import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { NectarMissionDetailForAuthorizedUser } from '@/features/missions/MissionsWrappers'
import { startProlificSession } from '@/features/nectar/prolific/api'
import { getProlificToken, setProlificSession } from '@/features/nectar/prolific/session'
import { Page } from '@/ui-kit'
import { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

const ProlificTaskPage = () => {
  const { projectId } = useParams<{ projectId: string }>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [isBootstrapping, setIsBootstrapping] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const prolificPid = searchParams.get('PROLIFIC_PID')
    const studyId = searchParams.get('STUDY_ID')
    const sessionId = searchParams.get('SESSION_ID')
    const hasProlificParams = !!prolificPid || !!studyId || !!sessionId

    if (!hasProlificParams) {
      if (!getProlificToken()) {
        setError('Your study session is missing. Please return to Prolific and re-open the study from your dashboard.')
      }
      return
    }

    if (!prolificPid || !studyId || !sessionId) {
      setError('This study link is missing required parameters.')
      return
    }

    setIsBootstrapping(true)
    setError(null)
    startProlificSession({ prolificPid, studyId, sessionId })
      .then((res) => {
        if (cancelled) return
        setProlificSession(res.token, res.completionUrl)
        navigate(`/missions/prolific/${res.projectId}/tasks`, { replace: true })
      })
      .catch(() => {
        if (!cancelled) setError('This study is not available right now.')
      })
      .finally(() => {
        if (!cancelled) setIsBootstrapping(false)
      })

    return () => {
      cancelled = true
    }
  }, [searchParams, navigate])

  if (error || isBootstrapping || !getProlificToken()) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
        {error ? <p className="text-red-500">{error}</p> : <p>Setting up your study session...</p>}
      </div>
    )
  }

  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        <NectarMissionDetailForAuthorizedUser missionId={projectId ?? ''} />
      </Page>
    </MissionsUrlProvider>
  )
}

export default ProlificTaskPage
